import { useMemo, useState, type ReactNode } from 'react';
import { NewOrganizationModal } from '@/features/organizations/NewOrganizationModal';
import { CreateSiteModal } from '@/features/sites/CreateSiteModal';
import { GlobalActionsContext, type GlobalActions } from '@/shell/globalActions';

/** Implements the shell's global actions with the features' modals. */
export function GlobalActionsProvider({ children }: { children: ReactNode }) {
  const [createSite, setCreateSite] = useState<{ organizationId?: string } | null>(null);
  const [newOrg, setNewOrg] = useState(false);
  const actions = useMemo<GlobalActions>(
    () => ({ openCreateSite: (organizationId) => setCreateSite({ organizationId }), openNewOrganization: () => setNewOrg(true) }),
    [],
  );
  return (
    <GlobalActionsContext.Provider value={actions}>
      {children}
      {createSite && <CreateSiteModal organizationId={createSite.organizationId} onClose={() => setCreateSite(null)} />}
      {newOrg && <NewOrganizationModal onClose={() => setNewOrg(false)} />}
    </GlobalActionsContext.Provider>
  );
}
